export default "__VITE_ASSET__Bx3sPp5r__"